import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=e4a033b0&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=e4a033b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a033b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a033b0')) {
      api.createRecord('e4a033b0', component.options)
    } else {
      api.reload('e4a033b0', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=e4a033b0&scoped=true&", function () {
      api.rerender('e4a033b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/category/widget.vue"
export default component.exports